import React from 'react';
import { withTranslation } from 'react-i18next';
import { translation } from '../../i18n';
import { Collapse } from 'reactstrap';

import { ApplicationState } from '../../store/store';
import { connect } from 'react-redux';

export interface SidebarUserBlockProps {
    showUserBlock: boolean,
    user: string,
    email: string
}

const SidebarUserBlock: React.FC<SidebarUserBlockProps> = (props) => {
    //const [showUserBlock, setshowUserBlock] = useState (false);
    const showUserBlock = false;

    return (
        <Collapse id="user-block" isOpen={ showUserBlock }>
            <div>
                <div className="item user-block">
                    {/* User picture */}
                    <div className="user-block-picture">
                        <div className="user-block-status">
                            <img className="img-thumbnail rounded-circle" src="img/user/02.jpg" alt="Avatar" width="60" height="60" />
                            <div className="circle bg-success circle-lg"></div>
                        </div>
                    </div>
                    {/* Name and Job */}
                    <div className="user-block-info">
                        <span className="user-block-name">{props.user}</span>
                        <span className="user-block-email">{props.email}</span>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    showUserBlock: state.settings.showUserBlock,
    user: state.security.user,
    email: state.security.email
});

export default connect(mapStateToProps)(withTranslation(translation)(SidebarUserBlock));